/**
 *
 * Records Page
 *
 */
import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Label,
  // Table,
  FormGroup,
  Input,
  Button,
  Spinner,
  Card,
  CardBody,
} from "reactstrap"
import Modal from "react-bootstrap/Modal"
import { withRouter, useParams } from "react-router-dom"
import ButtonSpinner from "../../components/ButtonSpinner"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as employeeAction from "../../store/ZW1wbG95ZWVJbnN0/actions"
import { useSelector, useDispatch } from "react-redux"
import Select from "react-select"
import { isEmpty } from "lodash"
import { ToastContainer} from "react-toastify"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import api from "../../helpers/Api"

//Import Styles
import "./styles.scss"
import moment from "moment"

const EmployeeInstantRequest = (props) => {
  const { dispatch, searchBtnStyle } = props
  const specificDispatch = useDispatch()
  let { id } = useParams()
  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
   const [downloadLoading, setDownloadLoading] = useState(false)
  //Search value
  const [searchValueList, setSearchValueList] = useState({})

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,

        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          searchFilter: searchInput,
        }

  useEffect(() => {
    dispatch(employeeAction.loadEmployeeRequest({
      page: 1, limit: 50
    }))
    dispatch(employeeAction.loadRecordsMetaData())
    dispatch(employeeAction.loadProcessStatus("hrms"))

  }, [])


  const employeeUpdate = useSelector(
    (specificstate) => specificstate.employeeInstantRequest
  )
  const {
    employee_request = [],
    recordsMetaData = {},
    process_status = [],
  } = employeeUpdate
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate


  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""


  const [btnLoader, setBtnLoader] = useState(false)
  const [processRequest, setProcessRequest] = useState(false)
  const handleProcess = () => setProcessRequest(false)

  const [employeeData, setEmployeeData] = useState({
    companyid: id,
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    responseStatus: [],
  })

  const handleChange = (e) => {
    setEmployeeData({ ...employeeData, [e.target.name]: e.target.value })
  }

  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [process, setProcess] = useState([])
  const [designation, setDesignation] = useState([])

  const branchOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === companies.value
    )
  const designationOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.designationOptions.filter(
      (designation) => designation.departmentId === departmentList.value
    )

  const processStatusList =
    !isEmpty(process_status) &&
    process_status.map((process) => {
      return {
        _id: process._id,
        colorCode: process.colorCode,
        description: process.description,
        mode: process.mode,
        processStatus: process.processStatus,
        processStatusId: process.processStatusId,
        shortCode: process.shortCode,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
          ; (obj.value = element._id),
            (obj.label = element.processStatus),
            (obj.colorCode = element.colorCode),
            (obj.mode = element.mode),
            (obj.processStatusId = element.processStatusId),
            options.push(obj)
      })
    return options
  }

  const processStatusOptions = createOptions(processStatusList)

  const handleApply = (e) => {
    e.preventDefault()
    // const processStatus = process.processStatusId
    var searchCompany = companies && companies.value ?companies.value : ""
    var searchBranch = branches && branches.value ? branches.value : ""
    var searchDepartment =
      departmentList && departmentList.value ? departmentList.value : ""
    var searchProcess =
      process && process.value ? [process.processStatusId] : ""
    var searchDesignation =
      designation && designation.value ? designation.value : ""
    var searchFromDate =
      employeeData && employeeData.fromDate ? employeeData.fromDate : ""
    var searchToDate =
      employeeData && employeeData.toDate ? employeeData.toDate : ""

    var searchvalue = {} 
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50
    if (searchCompany) {
      searchvalue.company = searchCompany
    }
    if (searchBranch) {
      searchvalue.branch = searchBranch
    }
    if (searchDepartment) {
      searchvalue.department = searchDepartment
    }
    if (searchDesignation) {
      searchvalue.designation = searchDesignation
    }
    if (searchProcess) {
      searchvalue.requestedStatus = searchProcess
    }
    if (searchFromDate) {
      searchvalue.startDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.endDate = searchToDate
    }

    setSearchValueList(searchValue)
    specificDispatch(employeeAction.loadEmployeeRequest(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }


  const resetFormDetails = () => {
    // e.preventDefault()
    setDepartmentList([])
    setProcess([])
    setCompanies([])
    setBranches([])
    setDesignation([])
    setEmployeeData({
      fromDate: "",
      toDate: "",
    })
      dispatch(employeeAction.loadEmployeeRequest({
        page:1, limit:50
    }))
  }

  //Update section


  const [requestId, setRequestId] = useState("")
  const [isLoading, setIsLoading] = useState("")
  const [requestNo, setRequestNo] = useState("")
  const [requestStatus, setRequestStatus] = useState("")
  //

  let slNo = 0
  const employeeDataTable = !isEmpty(employee_request)
    ? employee_request.data.map((employee, index) => {
      slNo = slNo + 1

      const appliedDate =
        !isEmpty(employee) && employee.createdOn
          ? moment(employee.createdOn)
            .subtract(5, "hours")
            .subtract(30, "minutes")
            .format(`${dateFormate} hh:mm A`)
          : "--"
      return {
        _id: employee._id,
        sNo: slNo,

        reponseNotes: !isEmpty(employee.response) ? employee.response[0].notes : "--",
        branchId: employee.branchId,
        branchName: employee.branchName,
        companyId: employee.companyId,
        companyName: employee.companyName,
        departmentId: employee.departmentId,
        appliedDate: appliedDate,
        departmentName: employee.departmentName,
        description: employee.remarks?employee.remarks:"--",
        designationId: employee.designationId,
        designationName: employee.designationName,
        employeeCode: employee.empCode,
        employeeName: employee.employeeName,
        requestNo: employee.requestNo,
        requestStatus: employee.requestStatusName,
        responseEmployeeCode: employee.responseEmployeeCode,
        responseEmployeeName: !isEmpty(employee.response)?employee.response[0].responseEmployeeName:"--",
        responseBy: !isEmpty(employee.response) ?
        employee.responseEmployeeCode  + "-" +  employee.response[0].responseEmployeeName: "--"
        ,
        subject: employee.subject,
        key: index,
        requestDate: employee.requestDate ? moment(employee.requestDate).format(dateFormate) : "--"
      }
    })
    : []

  //pagination table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "requestNo",
      text: "Request No",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "employeeCode",
      text: "Code",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "employeeName",
      text: "Employee Name",
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "departmentName",
      text: "Department",
      sort: true,
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "subject",
      text: "Subject",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "description",
      text: "Remarks",
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "requestStatus",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          row.requestStatus?<Button
            type="submit"
            className={
              row.requestStatus === "Accepted"
                ? "btn btn-success disabled-button"
                : "btn btn-warning"
            }
            onClick={() => {
              setProcessRequest(true)
              setRequestId(row._id)
              setRequestNo(row.requestNo)
              setRequestStatus(row.requestStatus)
              editEmployeeDetails(row)
            }}
            style={{ width: "80px", padding: "3px 5px" }}
          >
            {row.requestStatus}
          </Button>:"--"
        )
      },
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "requestDate",
      text: "Request Date",
      sort: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "reponseNotes",
      text: "Response Remarks",
      sort: true,
      headerStyle: {
        minWidth: "175px",
      },
    },
    {
      dataField: "responseBy",
      text: "Responsed By",
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "appliedDate",
      text: "Applied Date",
      sort: true,
      headerStyle: {
        minWidth: "155px",
      },
    },
  ]
  // const [submittedResponse, setSubmittedResponse] = useState(true)

  const updateProcessStatus = createOptions(processStatusList)

  const updateProcessStatusOptions =
    !isEmpty(updateProcessStatus) &&
    updateProcessStatus.filter((process) => {
      return process.label !== requestStatus
    })


  const [updateProcess, setUpdateProcess] = useState([])
  const [updateData, setUpdateData] = useState({
    responseNotes: "",
    responseStatus: [],
  })

  const updateChange = (e) => {
    setUpdateData({ ...updateData, [e.target.name]: e.target.value })
  }


  const editEmployeeDetails = (employee) => {
    setUpdateProcess({ label: employee.requestStatus, value: "" })
    setUpdateData({
      ...updateData,
      responseNotes: employee.ReponseNotes,
      responseStatus: [{ label: employee.requestStatus, value: "" }],
    })
  }

  const updateEmployee = () => {
    const payload = {
      
    "_id": requestId,
    "response": {
        "status":  updateProcess.processStatusId,
        "notes": updateData.responseNotes,
    }
    }
    
    specificDispatch(employeeAction.updateEmployeeRequest(payload))
    setIsLoading(true)
    setTimeout(() => {
      setProcessRequest(false)
      specificDispatch(employeeAction.loadEmployeeRequest(searchValue))
      setIsLoading(false)
      // setSubmittedResponse(true)
    }, 2000)
  }



  const title = "Employee Instant Request"




  //Search filter
  const [loading, setLoading] = useState(false)
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      employeeAction.loadEmployeeRequest({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,

      })
    )

    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  const exportToCsv = () => {
    var searchCompany = companies && companies.value ?companies.value : ""
    var searchBranch = branches && branches.value ? branches.value : ""
    var searchDepartment =
      departmentList && departmentList.value ? departmentList.value : ""
    var searchProcess =
      process && process.value ? [process.processStatusId] : ""
    var searchDesignation =
      designation && designation.value ? designation.value : ""
    var searchFromDate =
      employeeData && employeeData.fromDate ? employeeData.fromDate : ""
    var searchToDate =
      employeeData && employeeData.toDate ? employeeData.toDate : ""

    var searchvalue = {}
    if (searchCompany) {
      searchvalue.company = searchCompany
    }
    if (searchBranch) {
      searchvalue.branch = searchBranch
    }
    if (searchDepartment) {
      searchvalue.department = searchDepartment
    }
    if (searchDesignation) {
      searchvalue.designation = searchDesignation
    }
    if (searchProcess) {
      searchvalue.requestedStatus = searchProcess
    }
    if (searchFromDate) {
      searchvalue.startDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.endDate = searchToDate
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/employee_instant_response_excel_export`, searchvalue)
      .then((response) => {


        const photoExportDataTable = !isEmpty(response.data.Data)
          ? response.data.Data.map((employee,index) => {

            const appliedDate =
            !isEmpty(employee) && employee.createdOn
              ? moment(employee.createdOn)
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format(`${dateFormate} hh:mm A`)
              : "--"
            const notes = !isEmpty(employee.response) ? employee.response[0].notes:""
            const notesValue = !isEmpty(notes)
            ? notes.replace(/[\r\n,.]/gm, "")
            : "--"
            const remarks = !isEmpty(employee.remarks)? employee.remarks:""
            const remarksValue = !isEmpty(remarks)
            ? remarks.replace(/[\r\n,.]/gm, "")
            : "--"
            return {
              _id: employee._id,
              sNo: index + 1,
              reponseNotes: notesValue,
              branchId: employee.branchId,
              branchName: employee.branchName,
              companyId: employee.companyId,
              companyName: employee.companyName,
              departmentId: employee.departmentId,
              appliedDate: appliedDate,
              departmentName: employee.departmentName,
              description: remarksValue,
              designationId: employee.designationId,
              designationName: employee.designationName,
              employeeCode: employee.empCode,
              employeeName: employee.employeeName,
              requestNo: employee.requestNo,
              requestStatus: employee.requestStatusName?employee.requestStatusName:"--",
              responseEmployeeCode: employee.responseEmployeeCode,
              responseEmployeeName: !isEmpty(employee.response)?employee.response[0].responseEmployeeName:"--",
              responseBy: !isEmpty(employee.response) ?
              employee.responseEmployeeCode  + "-" +  employee.response[0].responseEmployeeName: "--"
              ,
              subject: employee.subject,
              key: index,
              requestDate: employee.requestDate ? moment(employee.requestDate).format(dateFormate) : "--"
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Company,Branch,Request No,Employee Code, Employee Name,Department,Subject,Remarks,Status,Request Date,Response Remarks,Responsed By,Applied Date",
          ]

          let usersCsv =
            !isEmpty(photoExportDataTable) &&
            photoExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                companyName,
                branchName,
                requestNo,
                employeeCode,
                employeeName,
                departmentName,
                subject,
                description,
                requestStatus,
                requestDate,
                responseNotes,
                responseBy,
                appliedDate
              } = user
              acc.push([
                sNo,
                companyName,
                branchName,
                requestNo,
                employeeCode,
                employeeName,
                departmentName,
                subject,
                description,
                requestStatus,
                requestDate,
                responseNotes,
                responseBy,
                appliedDate
              ])

              return acc
            }, [])
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "EmployeeInstatntRequest.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >

                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >

                          <Button
                            className="btn btn-primary"
                             onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          noDataIndication={"No Data Found..."}
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: employee_request.length,
    data:
      !isEmpty(employee_request) && employee_request.length > 0
        ? employee_request.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(employee_request) && employee_request.length > 0
        ? employee_request
        : []
    if (
      !isEmpty(employeeData.toDate) ||
      !isEmpty(employeeData.fromDate) ||
      !isEmpty(designation) ||
      !isEmpty(process) ||
      !isEmpty(departmentList) ||
      !isEmpty(branches) ||
      !isEmpty(companies)
    ) {
      var searchCompany = companies && companies.value ?companies.value : ""
      var searchBranch = branches && branches.value ? branches.value : ""
      var searchDepartment =
        departmentList && departmentList.value ? departmentList.value : ""
      var searchProcess =
        process && process.value ? [process.processStatusId] : ""
      var searchDesignation =
        designation && designation.value ? designation.value : ""
      var searchFromDate =
        employeeData && employeeData.fromDate ? employeeData.fromDate : ""
      var searchToDate =
        employeeData && employeeData.toDate ? employeeData.toDate : ""

      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      if (searchCompany) {
        searchvalue.company = searchCompany
      }
      if (searchBranch) {
        searchvalue.branch = searchBranch
      }
      if (searchDepartment) {
        searchvalue.department = searchDepartment
      }
      if (searchDesignation) {
        searchvalue.designation = searchDesignation
      }
      if (searchProcess) {
        searchvalue.requestedStatus = searchProcess
      }
      if (searchFromDate) {
        searchvalue.startDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.endDate = searchToDate
      }

      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(employeeAction.loadEmployeeRequest(searchvalue))
    } else {
      dispatch(
        employeeAction.loadEmployeeRequest({
          page: page,
          limit: sizePerPage
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"HRMS"} breadcrumbItem={title} />
        
          <Row>
            <Col
              lg="12"
              md="12"
              sm="12"
              xs="12"
              className="employee-request-card"
              style={{ paddingRight: "18px" }}
            >
              <Card>
                <CardBody>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.companyOptions
                              : []
                          }
                          classNamePrefix="select2-selection"
                          placeholder="Select Company"
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                          options={branchOptions}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Department"}
                          >
                            {"Department"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="department"
                          value={departmentList}
                          onChange={(e) => setDepartmentList(e)}
                          placeholder="Select Department"
                          classNamePrefix="select2-selection"
                          options={
                            recordsMetaData
                              ? recordsMetaData.departmentOptions
                              : []
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Response status"}
                          >
                            {"Designation"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="designation"
                          value={designation}
                          onChange={(e) => setDesignation(e)}
                          placeholder="Select Designation"
                          classNamePrefix="select2-selection"
                          options={designationOptions}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">From Date</Label>
                      <Input
                        type="date"
                        name="fromDate"
                        value={employeeData.fromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Select Date"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="event-label">To Date</Label>
                      <Input
                        type="date"
                        name="toDate"
                        value={employeeData.toDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Select Date"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <FormGroup>
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Response status"}
                          >
                            {"Response status"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="process"
                          value={process}
                          onChange={(e) => setProcess(e)}
                          placeholder="Select Response Status"
                          classNamePrefix="select2-selection"
                          options={processStatusOptions}
                        />
                      </FormGroup>
                    </Col>
                    <Col
                      xl="12"
                      lg="12"
                      md="12"
                      sm="12"
                      xs="12"
                      className="filter-section mt-1"
                    >
                      <div className="filter-buttons">
                        <button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          onClick={() => resetFormDetails()}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </button>
                        <button
                          type="submit"
                          className="btn btn-success btn-label"
                          onClick={(e) => handleApply(e)}
                        >
                          <i
                            className="mx-2 bx bx-filter-alt label-icon"
                            style={{ fontSize: "12px" }}
                          ></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Col className="employee-request1-card">
            <Row>
              <Col md="12" lg="12" xl="12" className="h-100 mt-3 mb-3">
                <Card>
                  <CardBody>
                    <div
                      className="d-flex flex-row"
                      style={{ marginTop: "20px" }}
                    >
                      <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                        <form onSubmit={handleClick} className="d-flex flex-row">
                          <div style={searchBtnStyle || null}>
                            <Input
                              type="text"
                              name="searchInput"
                              value={searchInput}
                              onChange={(e) => setSearchInput(e.target.value)}
                              className="form-control"
                              placeholder="Search"
                              style={{ position: "relative" }}
                            />
                            <i
                              className="bx bx-search-alt"
                              style={{
                                position: "absolute",
                                top: "54px",
                                left: "41px",
                                fontSize: "13px",
                              }}
                            />
                          </div>
                          <button
                            className="btn btn-success mx-2"
                            type="submit"
                            style={{
                              background: searchFilter ? "#2ca67a" : "",
                              color: searchFilter ? "#ffffff" : "",
                            }}
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </form>
                      </div>
                    </div>{" "}
                    <RemotePagination
                      data={employeeDataTable}
                      page={page}
                      sizePerPage={sizePerPage}
                      totalSize={
                        employee_request.totalDataCount
                          ? employee_request.totalDataCount
                          : 0
                      }
                      onTableChange={handleTableChange}
                    />
                    {loading ? (
                      <Modal
                        show={loading}
                        style={{ width: "7%", margin: "18% 50%" }}
                      >
                        <Modal.Body>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                          />
                        </Modal.Body>
                      </Modal>
                    ) : (
                      ""
                    )}
                    {btnLoading ? (
                      <Modal
                        show={btnLoading}
                        style={{ width: "7%", margin: "18% 50%" }}
                      >
                        <Modal.Body>
                          <Spinner
                            as="span"
                            animation="grow"
                            size="lg"
                            role="status"
                            aria-hidden="true"
                            variant="success"
                            className="mx-2"
                            color="success"
                          />
                        </Modal.Body>
                      </Modal>
                    ) : (
                      ""
                    )}
                    {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}


                  </CardBody>
                </Card>

                {processRequest && (
                  <Modal show={processRequest} onHide={handleProcess}>
                    <Modal.Header
                      style={{
                        backgroundColor: "#E40D8C",
                        color: "white",
                        minHeight: "65px",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      <div className="d-flex flex-row">
                        <span>REQUEST NO:</span>
                        <h1 className="request-header">{requestNo}</h1>
                      </div>
                    </Modal.Header>
                    <Modal.Body>
                      <Col>
                        <Row className="d-flex flex-column">
                          <Col
                            xl="12"
                            lg="12"
                            md="12"
                            sm="12"
                            xs="12"
                            className="d-flex flex-column"
                          >
                            <Label className="employee-label">
                              Response Notes
                            </Label>
                            <textarea
                              type="text"
                              name="responseNotes"
                              value={updateData.responseNotes}
                              onChange={(e) => updateChange(e)}
                              placeholder="Enter Response Notes"
                              className="employee-crowd-textarea"
                            />
                          </Col>
                          <Col
                            xl="6"
                            lg="6"
                            md="6"
                            sm="12"
                            xs="12"
                            className="mt-2"
                          >
                            <Label className="event-label">
                              Response Status
                            </Label>
                            <Select
                              type="text"
                              name="updateProcess"
                              value={updateProcess}
                              options={updateProcessStatusOptions}
                              onChange={(e) => setUpdateProcess(e)}
                              placeholder="Select Response Status"
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        className="btn btn-danger"
                        onClick={handleProcess}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        className="btn btn-success"
                        onClick={() => {
                          handleProcess()
                          updateEmployee()
                        }}
                      >
                        Submit
                      </Button>
                    </Modal.Footer>
                  </Modal>
                )}
              </Col>
              {isLoading ? (
                <Modal
                  show={isLoading}
                  style={{ width: "10%", margin: "20% 50%" }}
                >
                  <Modal.Body>
                    <Spinner
                      as="span"
                      animation="grow"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                      variant="success"
                      className="mx-2"
                    />
                    <span>Loading...</span>
                    {/* <span>Response Successfully Updated</span> */}
                  </Modal.Body>
                </Modal>
              ) : (
                ""
              )}

             
            </Row>
          </Col>
          <ToastContainer
            position="top-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

EmployeeInstantRequest.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  employee_request: PropTypes.array,
  process_status: PropTypes.array,
  error: PropTypes.any,
  access: PropTypes.array,
  metaData: PropTypes.object,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  employee_request: state.employeeRequest.employee_request,
  process_status: state.employeeRequest.process_status,
})

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
//EmployeeInstantRequest
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmployeeInstantRequest)
)
